module.exports = __webpack_public_path__ + "static/Garden_Sheds-2e7652ffe5f7c5d0929a9e15655e8729.png";